export const localStorageKeys = {
    whiteboardState: 'whiteboard_state', // State that persists between page loads / BOR joining + leaving.
    userUuid: 'user_uuid'
};
